// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._808872{--gutter: 0.25em}._6a0620{opacity:.5}.a7ebc5{letter-spacing:-0.04em;min-width:3.5em;text-align:center;font-weight:600}", ""]);
// Exports
exports.locals = {
	"pager": "_808872",
	"icon": "_6a0620",
	"text": "a7ebc5"
};
module.exports = exports;
